module.exports = __webpack_public_path__ + "static/media/pc2.88804141.webp";